<div class="d-flex flex-row flex-justify-start w-px-8 w-py-6 background">
    <span class="w-h1-bold w-color-secondary-pt9">©2023 {{  ebbName }}</span>
</div>